/* eslint-disable no-nested-ternary */
import React, { ReactElement, useContext, useEffect, useState } from 'react';

import { Header as CHeader, Col, Progress, Row } from '@components/atoms';
import { Page, requiredSurveys } from '@constants/enum';
import PageIndexContext from '@containers/Context/PageIndexContext';
import { useReduxForm } from '@hooks/useReduxForm';
// import { parsingSurveyObjToCodeMapper, sCodeMapper } from '@utils/surveyUtils';
import _ from 'lodash';

export default function Header(): ReactElement {
  const { pageIndex } = useContext(PageIndexContext);

  const { formData = {} } = useReduxForm('survey');
  const {
    currentSurvey: c,
    surveyList,
    selectedMainSurveyCode,
    mainSurveyList,
    selectedOptionalSurveyList = [],
  } = formData;
  const [progressIndex, setProgressIndex] = useState(0);
  const logoFlag = [
    Page.Init,
    Page.Term,
    Page.Continue,
    Page.End,
    Page.NotFoundError,
    Page.Completed,
    Page.Expired,
    Page.Review,
    Page.TreatmentIsProgressing,
  ].includes(pageIndex);
  const noHeaderFlag = [
    Page.B2CMain,
    Page.ServiceTerm,
    Page.PersonalInfoTerm,
    Page.ModeSelect,
    Page.B2CForm,
    Page.B2CResult,
    Page.B2CSolution,
    Page.B2CAdditionalSurvey,
  ].includes(pageIndex);

  useEffect(() => {
    // sCodeMapper();
    // parsingSurveyObjToCodeMapper();
    if (!logoFlag) {
      let index = 0;
      switch (pageIndex) {
        case Page.OptionalSurveys:
          index = _.uniq([
            selectedMainSurveyCode,
            ..._.filter(mainSurveyList, (k: string) => requiredSurveys.includes(k)),
          ]).length;
          break;
        case Page.MainSymptom:
          break;
        case Page.Confirm:
          index = 100;
          break;
        default:
          index = surveyList?.findIndex((k: string) => c?.startsWith(k)) + 1 ?? 0;
          break;
      }
      setProgressIndex(index);
    }
  }, [c, pageIndex]);

  return (
    <CHeader>
      {logoFlag ? (
        <Row yzTypeRow="header">
          <Col yzTypeCol="header-logo">
            <img alt="termImg" src={`${process.env.PUBLIC_URL}/img/ygLogo4x.webp`} width="61px" />
          </Col>
        </Row>
      ) : !noHeaderFlag ? (
        <Progress
          percent={
            pageIndex === Page.End
              ? 100
              : (progressIndex / _.uniq([...surveyList, ...selectedOptionalSurveyList])?.length) * 100 ?? 1
          }
          showInfo={false}
          strokeColor="#D5E8FF"
          strokeLinecap="square"
          style={{ top: '-7px' }}
        />
      ) : (
        <></>
      )}
    </CHeader>
  );
}
